import React from 'react'
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';

import {
  renderBody,
} from '../helpers'

// report_image action is not a dispatcher
import {
  report_image
} from '../actions'

class TestQuestion extends React.Component {
  state = {
    blob: null
  }

  render() {
    const { question, index } = this.props
    const self = this
    const printIndex = (index < 10) ? `0${index}` : index
    const { id, level, type, competency, instructions, body, answers, correct, version_id, human_time } = question
    const icon = correct ? 'check_circle' : 'cancel'
    const header = {
      "Text": 'Choose the right answer',
      "Audio": 'Listen carefully and choose the right answer',
      "Image": 'Choose the right answer'
    }
    if (type === 'Image' && this.state.blob === null) {
      report_image(id, version_id).then(data => {
        self.setState({blob: URL.createObjectURL(data)})
      }).catch( err => console.log(err) )
    }

    return (
      <div className="test_question_report">
        <Grid container spacing={24} justify="space-between" alignItems="center">
          <Grid item md={11} xs={10}>
            <div className="test_question_row">
              <span className="test_question_index">{printIndex}</span>
              <span className="test_question_meta">ID: {id} • Level: {level} • Competency: {competency} • Type: {type} • Time Taken: {human_time}</span>
            </div>
            <div className="test_question_row">
              <span className="test_question_header">{header[type]}</span>
            </div>
            {instructions && (
              <div className="test_question_row">
                <span className="test_question_instructions">{instructions}</span>
              </div>
            )}
            {
              type === 'Image' && this.state.blob !== null && (
                <div className="test_question_row">
                  <img src={this.state.blob} alt="Question" height={200} />
                </div>
              )
            }
            <div className="test_question_row">
              <span className="test_question_body">{renderBody(body)}</span>
            </div>
            <div className="test_question_row">
              <div className="test_question_answers">
                {
                  answers.map((answer, i) => {
                    const radio = answer.chosen ? 'radio_button_checked' : 'radio_button_unchecked'
                    const classname = answer.right ? 'answer_is_right' : ''
                    return (
                      <Grid container key={`ans_${i}`} className={classname} justify="flex-start" spacing={24} alignItems="center">
                        <Grid item md={1} xs={1} style={{maxWidth:24}}>
                          <Icon fontSize="small" style={{transform: 'translateY(2px)'}}>{radio}</Icon>
                        </Grid>
                        <Grid item md={11} xs={10}>
                          {answer.body}
                        </Grid>
                      </Grid>
                    )
                  })
                }
              </div>
            </div>
          </Grid>
          <Grid item md={1} xs={2}>
            <Icon>{icon}</Icon>
          </Grid>
        </Grid>
      </div>
    )
  }

}

export default TestQuestion



// WEBPACK FOOTER //
// ./src/js/components/TestQuestion.js